(function () {
    const rnd1d = num => Math.round(num * 10) / 10;
    const rnd = num => Math.round(num);
    //fix rounding glitch in css between 49 and 51.
    const formatCurrentPercent = num => (num >= 49 && num <= 51) ? rnd(num) : rnd1d(num);
    const animationDuration = 8000;
    const animationUpdate = 50;

    const setElemStyle = (elem, prop, val) => { elem.style.setProperty(prop, val) };
    window.addEventListener('DOMContentLoaded', () => {
        const progress = document.querySelector('.c-progress-pie');

        if (progress) {
            let currentTime = 0;
            let animInterval = setInterval(() => {
                if (currentTime <= animationDuration) {
                    const currentPercent = 100 / (animationDuration / currentTime);
                    setElemStyle(progress, '--p', formatCurrentPercent(currentPercent));
                    currentTime = currentTime + animationUpdate;
                } else {
                    clearInterval(animInterval);
                    setElemStyle(progress, '--p', 100);
                }
            }, animationUpdate)

        }
    })
}());
